// Porta direta de reference/expo-frontend/lib/competitionRank.ts —
// "competition ranking" (1224): itens empatados dividem a mesma posição.

export function competitionRanks<T>(
  sorted: readonly T[],
  tieKey: (item: T) => number,
): number[] {
  const ranks: number[] = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && tieKey(sorted[i]!) === tieKey(sorted[i - 1]!)) {
      ranks.push(ranks[i - 1]!);
    } else {
      ranks.push(i + 1);
    }
  }
  return ranks;
}

export function sharedRankFlags(ranks: readonly number[]): boolean[] {
  const counts = new Map<number, number>();
  for (const r of ranks) counts.set(r, (counts.get(r) ?? 0) + 1);
  return ranks.map((r) => (counts.get(r) ?? 0) > 1);
}

export function formatCompetitionRank(rank: number, _tied: boolean): string {
  return `#${rank}`;
}
